import { render, staticRenderFns } from "./kTojIndex.vue?vue&type=template&id=03359180&"
import script from "./kTojIndex.vue?vue&type=script&lang=js&"
export * from "./kTojIndex.vue?vue&type=script&lang=js&"
import style0 from "./kTojIndex.vue?vue&type=style&index=0&id=03359180&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports